import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (

  <div className="container">
    <div className="row items">

      <div className="col-lg-4">
        <a href="/about"><div className="ratio block-me"></div></a>
        <h4><a href="/about">Hire me!</a></h4>
        <p>Your company needs an Anthropologist.</p>
      </div>

      <div className="col-lg-4">
        <a href="/projects/auspost"><div className="ratio block-auspost"></div></a>
        <h4><a href="/projects/auspost">Australia Post</a></h4>
        <p>User Experience research in the postal industry</p>
      </div>

      <div className="col-lg-4">
        <a href="/projects/sunsmart"><div className="ratio block-sunsmart"></div></a>
        <h4><a href="/projects/sunsmart">UX Case Study: SunSmart 2014</a></h4>
        <p>An app from start to finish</p>
      </div>

    </div>

    <div className="row items">

      <div className="col-lg-4">
        <a href="/projects/age-friendly-communities"><div className="ratio block-project1"></div></a>
        <h4><a href="/projects/age-friendly-communities">Age Friendly Communities</a></h4>
        <p>A narrative research about age-friendly communities.</p>
      </div>

      <div className="col-lg-4">
        <a href="/projects/imagineering-dis-ability"><div className="ratio block-imagineering"></div></a>
        <h4><a href="/projects/imagineering-dis-ability">Imagineering Dis/Ability</a></h4>
        <p>A cultural anthropological research about the perception of dis/abled people and prosthetics.</p>
      </div>

      <div className="col-lg-4">
        <a href="/projects/familymovies-moviefamilies"><div className="ratio block-project3"></div></a>
        <h4><a href="/projects/familymovies-moviefamilies">Family Movies : Movie Families</a></h4>
        <p>Research about private home movie images from a cultural anthropological perspective.</p>
      </div>

    </div>

    <div className="row items">

      <div className="col-lg-4">
        <a href="/projects/travel-phenomena"><div className="ratio block-travel"></div></a>
        <h4><a href="/projects/travel-phenomena">Travel Phenomena </a></h4>
        <p>Research about the time and space perception of Backpacker and Flashpacker.</p>
      </div>

      <div className="col-lg-4">
        <a href="/projects/capoeira"><div className="ratio block-project5"></div></a>
        <h4><a href="/projects/capoeira">Capoeira: A Thick Description</a></h4>
        <p>An ethnographical movie of Capoeira</p>
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js